import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
// import { sEndPoint } from '.env.properties';
//set up environment variable
// export const sURL = 'https://scratch-api.aggregator.club/' + 'v1/api/';
// export const sURL = 'http://localhost:8080/' + 'v1/api/';
import { environment } from "../environments/environment";
import { Router } from "@angular/router";

export interface ApiResponse {
  result: any[];
  status: any;
}

@Injectable({ providedIn: "root" })
export class ApiService {
  $tokenRefreshed = new Subject<boolean>();
  $refreshToken = new Subject<boolean>();
  oRoles = null;
  oPermissions = null;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  clearUserToken() {
    localStorage.removeItem("app");
    localStorage.removeItem("lastActivityTime");
    this.oPermissions = null;
  }

  get permissions() {
    const userData = this.getUserData();
    return userData.PERMISSIONS.split(",");
  }

  getRoles() {
    return this.oRoles;
  }

  saveUserToken(data: any) {
    localStorage.setItem("app", JSON.stringify(data));
    let oData = JSON.parse(atob(data.access_token.split(".")[1]));
    let oUserFields = oData.user_fields;
    this.oRoles = oUserFields.ROLES;
    this.oPermissions = oUserFields.PERMISSIONS;
  }

  getUserToken() {
    const oSessionData = localStorage.getItem("app");
    if (oSessionData != null) {
      return JSON.parse(oSessionData);
    }
    return null;
  }

  getUserData() {
    let oUserData = this.getUserToken();
    let oData = JSON.parse(atob(oUserData.access_token.split(".")[1]));
    let oUserFields = oData.user_fields;
    let id = oUserFields.ID;
    let name = oUserFields.NAME;
    let email = oUserFields.EMAIL;
    let roles = oUserFields.ROLES;
    let permissions = oUserFields.PERMISSIONS;
    let parentId = oUserFields.PARENT_ID;
    let domainId = oUserFields?.DOMAIN_ID;
    let parentRole = oUserFields.PARENT_ROLE;

    return {
      ID: id,
      NAME: name,
      EMAIL: email,
      PARENT_ID: parentId,
      ROLE: roles,
      PERMISSIONS: permissions,
      DOMAIN_ID: domainId,
      PARENT_ROLE: parentRole,
    };
  }

  performTokenRefresh() {
    let url = environment.bURL + "/v1/auth/renew";
    const refreshToken = JSON.parse(localStorage.getItem("app") ?? "{}")?.refresh_token;

    if (refreshToken) {
      this.send2Server(url, true, null, {
        "refresh-token": refreshToken,
      }).subscribe({
        next: (response: any) => {
          console.log(response);
          if (response) {
            let oUserData = {
              access_token: response.access_token,
              refresh_token: response.refresh_token,
              user: response.user_fields,
            };
            this.saveUserToken(oUserData);
            window.location.reload();
          }
        },
        error: () => {
          this.logout();
        },
      });
    } else {
      this.logout();
    }
  }

  send2Server(url: string, bPost: boolean = false, oItem: any = null, extraHeaders?: Record<string, string | number>): Observable<any> {
    if (bPost) {
      return this.http.post<ApiResponse>(url, oItem, this.getHeaders(extraHeaders));
    }
    return this.http.get<ApiResponse>(url, this.getHeaders());
  }

  getURL() {
    return environment.sURL;
  }
  getRiskCalculatorURL() {
    return environment.riskCalculatorURL;
  }

  getHeaders(extraHeaders?: Record<string, string | number>): any {
    var oHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      ...extraHeaders,
    });
    return { headers: oHeaders };
  }

  getDomainName(): string | null {
    let hostname = window.location.hostname;
    if (!hostname) {
      return null;
    }

    const parts = hostname.split(".");
    if (parts.length >= 2) {
      return parts.slice(-2).join(".");
    }

    return hostname;
  }

  async performLogin(uname: string, pwd: string): Promise<UserDataType | null> {
    let code = localStorage.getItem("countryCode");
    let domainName = this.getDomainName();
    // let domainName = 'freedemokit.com';

    if (uname === "admin" && pwd === "admin123") {
      let oUserData = {
        access_token: "DEV_TOKEN",
        refresh_token: "",
        name: uname,
        domain_id: "",
        domain_name: domainName || "",
        is_2fa_enabled: "false",
        is_2fa_verified: "false",
        id: "",
      };

      return oUserData;
    }
    try {
      // domainName = "sadmincontrol.com";
      // domainName = "freedemokit.com";
      const data: any = await this.send2ServerRelative("auth/admin_login_v2", true, {
        USERNAME: uname,
        PASSWORD: pwd,
        COUNTRY_CODE: code,
        DOMAIN_NAME: domainName,
      }).toPromise();
      let oUserData = {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        name: data.user_fields.NAME,
        domain_id: data.user_fields.DOMAIN_ID,
        domain_name: data.user_fields.DOMAIN_NAME,
        is_2fa_enabled: data.user_fields.IS_2FA_ENABLED,
        is_2fa_verified: data.user_fields.IS_2FA_VERIFIED,
        id: data.user_fields.ID,
      };
      // this.saveUserToken(oUserData);
      return oUserData;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  logout() {
    this.clearUserToken();
    this.router.navigate(["authentication/login"]);
  }

  send2ServerRelative(sPartialURL: string, bPost: boolean = false, oItem: any = null): Observable<any> {
    if (bPost) {
      return this.http.post<ApiResponse>(this.getURL() + sPartialURL, oItem, this.getHeaders());
    }
    return this.http.get<ApiResponse>(this.getURL() + sPartialURL, this.getHeaders());
  }
}

export interface UserDataType {
  id: string;
  access_token: string;
  refresh_token: string;
  name: string;
  domain_id: string;
  domain_name: string;
  is_2fa_enabled: string;
  is_2fa_verified: string;
}
